<template>
  <div id="SavedSchools">
    <v-app-bar class="grey lighten-3 d-md-none" fixed elevate-on-scroll>
      <v-layout justify-center align-center>
        <v-icon color="light-blue darken-3" large>mdi-bookmark</v-icon>
        <span class="title blue--text text--darken-3 ml-1">
          My Saved PA Schools</span
        >
      </v-layout>
    </v-app-bar>

    <!-- Total Schools Saved Container -->
    <v-container class="pb-0 wrap">
      <v-card class=" card elevation-0" flat tile>
        <v-container pb-1>
          <v-layout row align-center justify-center>
            <v-layout column align-center>
              <span
                class="percentageValue display-3 blue__text__color font-weight-medium "
                >{{ savedSchools.length }}</span
              >
              <p class="mt-2 grey--text ">Total Schools Saved</p>
            </v-layout>
          </v-layout>
        </v-container>
      </v-card>
    </v-container>

    <!-- My Saved Schools Container -->
    <v-container mt-2 px-0 pt-0>
      <v-card flat outlined>
        <v-toolbar color="grey darken-3" dark flat>
          <v-toolbar-title>My Schools</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
            class="mr-1 elevation-0 "
            dark
            color="grey lighten-1"
            >Add PA School</v-btn
          >
          <v-btn
            v-else
            to="/paschools"
            class="mr-1 pa-2 elevation-6"
            dark
            color="#D49129"
            >Add PA School</v-btn
          >
        </v-toolbar>

        <v-card-text class="px-1 pt-0">
          <!-- Login or Signup Card -->
          <v-card v-if="!checkUserLoggedIn" class="elevation-0">
            <v-card-text class="text-center black--text"
              >You need an active subscription to add PA schools</v-card-text
            >
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  to="/LoginSignupPage"
                  style="width:40%"
                  class="elevation-0 mr-4"
                  color="green"
                  dark
                  @click="showCreateSubscriptionDialog = false;"
                >
                  Login
                </v-btn>

                <v-btn
                  to="/signup"
                  style="width:40%"
                  class="elevation-0"
                  color="primary"
                  @click="showCreateSubscriptionDialog = false;"
                >
                  Signup
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>

          <!-- Active Subscription Card -->
          <v-card v-else-if="!checkUserIsSubscribed" class="elevation-0">
            <v-card-text class="text-center black--text"
              >You need an active subscription to save schools</v-card-text
            >
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  to="/myaccount"
                  block
                  class="elevation-0"
                  color="primary"
                >
                  My Account
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>

          <!-- User Saved Schools -->
          <v-card
            v-else-if="checkUserLoggedIn && checkUserIsSubscribed"
            class=" pb-5  white px-3"
            flat
            tile
            style="marginBottom:50px"
          >
            <v-layout justify-center align-center id="filter">
              <v-select
                :items="
                  APPLICATION_STATUSES.map(key => {
                    return { text: APPLICATION_STATUSES_MAP[key], value: key };
                  })
                "
                label="Filter"
                v-model="activeFilter"
                outlined
                dense
                class="mx-1 mt-2 col-md-6"
              >
                <template v-slot:selection="{ item, index }">
                  <span>
                    {{ item.text }}
                    <span class="caption blue--text"
                      >{{ visibleSchools.length }} schools</span
                    >
                  </span>
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.text"
                    ></v-list-item-title>
                    <v-list-item-subtitle class="blue--text">
                      {{
                        schoolStatus(data.item.value).length
                      }}
                      schools</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-select>
            </v-layout>

            <v-row>
              <v-col
                v-for="savedSchool in visibleSchools"
                :key="savedSchool.id"
                md="4"
              >
                <SavedSchool
                  :savedSchool="savedSchool"
                  :visibleSchools="visibleSchools"
                />
              </v-col>
            </v-row>

            <v-container
              v-if="
                savedSchools.length === 0 &&
                  (user !== null && user !== undefined)
              "
              mt-3
              pt-2
            >
              <p
                class=" mb-0 text-center body-1 mt-0 pt-1 grey--text text--darken-4 font-weight-light"
              >
                You have no PA schools saved
              </p>
            </v-container>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>

    <v-btn
      class="mr-4 ml-2  fixed elevation-0 hidden-md-and-up "
      color="red"
      fab
      rounded
      small
      @click="back"
    >
      <v-icon medium color="white">mdi-arrow-left</v-icon></v-btn
    >
  </div>
</template>

<script>
import userMixins from "@/mixins/usersmixin";

const IN_PROGRESS = "IN_PROGRESS";
const IS_COMPLETE = "IS_COMPLETE";
const APPLIED = "APPLIED";
const INTERVIEW = "INTERVIEW";
const REJECTED = "REJECTED";
const ACCEPTED = "ACCEPTED";
const HOLD = "HOLD";

const STATUSES = [
  IN_PROGRESS,
  IS_COMPLETE,
  APPLIED,
  INTERVIEW,
  ACCEPTED,
  HOLD,
  REJECTED
];

const APPLICATION_STATUS = {
  IN_PROGRESS: "In Progress",
  IS_COMPLETE: "Ready to Apply",
  APPLIED: "Applied",
  INTERVIEW: "Called for Interview",
  ACCEPTED: "Accepted",
  HOLD: "Wait Listed",
  REJECTED: "Rejected"
};

export default {
  mixins: [userMixins],
  data() {
    return {
      show: false,
      showLogin: false,
      activeFilter: IN_PROGRESS,
      APPLICATION_STATUSES: STATUSES,
      APPLICATION_STATUSES_MAP: APPLICATION_STATUS
    };
  },
  methods: {
    back() {
      this.$router.push("/dashboard");
    },
    schoolStatus(data) {
      return this.savedSchools.filter(s => {
        const hasStatus = this.userSchoolApplications.find(
          sch => sch.id === s.id
        );
        if (!hasStatus) {
          return data === IN_PROGRESS;
        }
        return hasStatus.status === data;
      });
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userSchoolApplications() {
      return this.$store.getters.userSchoolApplications;
    },
    visibleSchools() {
      return this.schoolStatus(this.activeFilter);
    },
    savedSchools() {
      return this.$store.getters.savedSchools;
    }
  }
};
</script>

<style scoped>
@media (min-width: 900px) {
  #SavedSchools {
  }
}
.divider {
  opacity: 1;
}
.link {
  text-decoration: none;
}

.signupOrLoginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size: 20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}

.card {
  border-radius: 3px;
}

.fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: 65px;
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

img {
  width: 50px;
  height: 50px;
}

.linkLogo {
  width: 33px;
  height: 33px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}

.tweetLogo {
  width: 37px;
  height: 37px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
}
.blueHeading {
  color: #2196f3;
}

@media (max-width: 900px) {
  #filter {
    margin-top: 20px;
  }

  .wrap {
    margin-top: 5vh !important;
  }
}

@media (min-width: 900px) {
  #filter {
    margin-top: 30px;
  }
}

.blue__text__color {
  color: #005880;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/SavedSchools.vue